import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ReservePanel from './reservePanel';
import PhoneNumber from '../phoneNumber';

import { getStockAlertUrlFromStorage } from '@javascript/stock_alerts/helpers';
import StockAlertLauncher from '@components/stock_alerts/stockAlertLauncher';

const EnquiryPanel = ({
  reservationAvailable,
  vehicle,
  phoneNumber,
  submitEnquiryParamsForm,
  enquiryPath,
}) => {
  const [stockAlertUrl, setStockAlertUrl] = useState(vehicle.stockAlertUrl);

  useEffect(() => {
    const url = getStockAlertUrlFromStorage(vehicle.stockAlertUrl);
    setStockAlertUrl(url);
  }, []);

  return (
    <>
      {reservationAvailable && !vehicle.isReserved ? (
        <ReservePanel vehicle={vehicle} />
      ) : (
        <div className="ac-product__ctas ac-product__ctas--grey js-off--hide">
          {phoneNumber && (
            <p>
              Call now on{' '}
              <PhoneNumber
                additionalClasses="ac-product__ctas-phone"
                number={phoneNumber}
                origin="Product header"
              />
              *
            </p>
          )}
          <button
            className="ch-btn ch-btn--cta ch-btn--block ch-mb--1"
            data-event-name="Product page: Enquire Now CTA"
            data-gtm-track="click_cta"
            data-gtm-track-label="Enquire now button"
            data-insight-event="conversion"
            onClick={submitEnquiryParamsForm}
            type="button"
          >
            Enquire now
          </button>
          <p>Want to know when a similar car to this one comes into stock?</p>
          <StockAlertLauncher
            additionalStyling="ch-btn--block"
            stockAlertUrl={stockAlertUrl}
          />
        </div>
      )}
      <div className="js-on--hide ac-product__ctas">
        <a
          className="ch-btn ch-btn--cta ch-btn--block"
          href={enquiryPath}
          rel="nofollow"
        >
          Enquire now
        </a>
      </div>
    </>
  );
};

EnquiryPanel.propTypes = {
  enquiryPath: PropTypes.string,
  phoneNumber: PropTypes.string,
  reservationAvailable: PropTypes.bool,
  submitEnquiryParamsForm: PropTypes.func,
  vehicle: PropTypes.shape({
    isReserved: PropTypes.bool,
    stockReference: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    trim: PropTypes.string,
    stockAlertUrl: PropTypes.string,
  }),
};

export default EnquiryPanel;
